export default "__VITE_ASSET__Daduutsl__"